webpackJsonp([254572558124955],{

/***/ 789:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"2049MPCLGO","searchOnlyApiKey":"e41443b3fd6416560ab6a167ccbe61e0","indexName":"BlogIndex"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-20e6a68805ffe2f06e6a.js